import { render, staticRenderFns } from "./CopyReportBtn.vue?vue&type=template&id=58e09b5d&scoped=true&"
import script from "./CopyReportBtn.vue?vue&type=script&lang=js&"
export * from "./CopyReportBtn.vue?vue&type=script&lang=js&"
import style0 from "./CopyReportBtn.vue?vue&type=style&index=0&id=58e09b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e09b5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
